import { IService } from '../entities/IService';
import { httpClient } from './helper/httpClient';

export interface ICreateServiceParams {
  name: string;
  description?: string;
  price: number;
  imageUrl?: string;
}

export interface IUpdateServiceParams {
  name?: string;
  description?: string;
  price?: number;
  imageUrl?: string | null;
}

class ServiceService {
  private _baseURL = 'services';

  getAll(options?: {
    archived?: 'only' | 'include' | 'exclude';
  }): Promise<IService[]> {
    return httpClient.get<null, IService[]>(this._baseURL, {
      params: options?.archived ? { archived: options.archived } : undefined,
    });
  }

  getById(id: string): Promise<IService> {
    return httpClient.get<null, IService>(`${this._baseURL}/${id}`);
  }

  create(data: ICreateServiceParams): Promise<IService> {
    return httpClient.post<null, IService>(this._baseURL, data);
  }

  update(id: string, data: IUpdateServiceParams): Promise<IService> {
    return httpClient.patch<null, IService>(`${this._baseURL}/${id}`, data);
  }

  delete(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }

  restore(id: string): Promise<void> {
    return httpClient.post(`${this._baseURL}/${id}/restore`);
  }

  detachFromAllPackages(id: string): Promise<void> {
    return httpClient.post(`${this._baseURL}/${id}/detach`);
  }
}

export default new ServiceService();
